/** Contracting entity named in the Pubky Terms, Privacy Policy and footers. */
export const LEGAL_ENTITY_NAME = 'Synonym Software, S.A. de C.V.';
